package com.eladfinish.bible.contest.repository.remoteConfig

enum class RemoteConfig(val key: String) {
    ANNOUNCEMENT(key = "announcement"),
    DATES_OF_FREE_MIKUD(key = "DATES_OF_FREE_MIKUD"),
    NUMBER_OF_QUESTIONS(key = "NUMBER_OF_QUESTIONS"),
    OPEN_QUESTIONS_LAST_EDIT_SERVER(key = "openQuestionsLastEditServer"),
    TERUMA(key = "teruma"),
    VERSION_CODE(key = "versionCode"),
    FEATURE_FLAG_AI_SEARCH(key = "feature_flag_ai_search"),
    TELEGRAM_CHANNEL_URL(key = "telegram_channel_url"),
    IN_APP_REVIEW(key = "in_app_review"),

    // Search suggestions (docs/search/search-suggestions-plan.md, section 13). The kill switch is on
    // the negative: a missing parameter means the feature is on.
    DISABLE_SEARCH_SUGGESTIONS(key = "disable_search_suggestions"),
    SEARCH_SUGGESTIONS_MAX(key = "search_suggestions_max"),
    SEARCH_SUGGESTIONS_URL(key = "search_suggestions_url"),
    SEARCH_SUGGESTIONS_BLOCKLIST(key = "search_suggestions_blocklist"),

    // Past quizzes ("חידונים אמיתיים": a WebView into the district-quiz web app's exam mode). The kill
    // switch is on the negative: a missing parameter means the feature is on.
    DISABLE_PAST_QUIZZES(key = "disable_past_quizzes"),
    PAST_QUIZZES_URL(key = "past_quizzes_url"),
    DISABLE_PAST_QUIZZES_VOICE(key = "disable_past_quizzes_voice"),
    // The app's part of ראש בראש (duel links, the share sheet, no ad banner in a room); the game
    // itself is the page's and has its own switch there.
    DISABLE_PAST_QUIZZES_DUEL(key = "disable_past_quizzes_duel"),
    // The page's usage events into AppMetrica (Android only, with the usage-statistics consent).
    DISABLE_PAST_QUIZZES_APPMETRICA(key = "disable_past_quizzes_appmetrica"),
    // The one-time "what's new" sheet that introduces the button to existing users (the button
    // itself stays). Off as well whenever DISABLE_PAST_QUIZZES is on.
    DISABLE_PAST_QUIZZES_SHEET(key = "disable_past_quizzes_sheet"),

    // The home-screen widget "ווידג'ט פסוק מתחלף": switches off the main-screen tile and the settings
    // screen behind it (a widget already on a home screen keeps showing its verse). The kill switch is on
    // the negative: a missing parameter means the feature is on.
    DISABLE_VERSE_WIDGET(key = "disable_verse_widget"),

    // The one-time "what's new" sheet that introduces the widget to existing users (the tile itself
    // stays). Off as well whenever DISABLE_VERSE_WIDGET is on. Negative: a missing parameter means on.
    DISABLE_VERSE_WIDGET_SHEET(key = "disable_verse_widget_sheet"),

    // The picture that explains what a widget is, opened by "מה זה ווידג'ט?" on the widget's settings
    // screen. Used only when it is a plain https address; otherwise the built-in one.
    VERSE_WIDGET_EXAMPLE_IMAGE_URL(key = "verse_widget_example_image_url"),

    // The small hint on the random-verse screen that offers the widget. Off as well whenever
    // DISABLE_VERSE_WIDGET is on. Negative like it: a missing parameter means the hint is on.
    DISABLE_VERSE_WIDGET_PROMPT(key = "disable_verse_widget_prompt"),
}
